import Swiper from 'swiper'
import { A11y } from 'swiper/modules';

const mediaQuery = window.matchMedia('(max-width: 40.625em)')
let swiperInstances = []

function handleResizeChange (e) {
    // Check if the media query is true
    if (e.matches) {
        document.querySelectorAll('.contentCards .swiper').forEach((slider) => {
            swiperInstances = [...swiperInstances, new Swiper(slider, {
                modules: [A11y],
                enabled: true,
                slidesPerView: 1.25,
                spaceBetween: 30
            })]
        })
        return
    }

    swiperInstances.forEach((instance) => {
        instance.destroy(true, true)
    })
}

// Register event listener
mediaQuery.addListener(handleResizeChange)

// Initial check
handleResizeChange(mediaQuery)
